import { render } from "./UserMenu.vue?vue&type=template&id=0f92b785"
import script from "./UserMenu.vue?vue&type=script&lang=ts"
export * from "./UserMenu.vue?vue&type=script&lang=ts"

import "./UserMenu.vue?vue&type=style&index=0&id=0f92b785&lang=css"
script.render = render

export default script